import { createContext, useEffect, useState } from 'react';
import { publicRequest } from '../requestMethods';

const StoreContext = createContext(null);

const StoreProvider = ({ children }) => {
  // const [cart, setCart] = useLocalStorage('commerce_cart', []);

  // Store Filtration
  const [query, setQuery] = useState('');
  const [categoryIndex, setCategoryIndex] = useState(-1);
  const [price, setPrice] = useState(309999);

  // Store Grid
  const [sortByIndex, setSortByIndex] = useState(0);
  const [viewGrid, setViewGrid] = useState(true);
  const [products, setProducts] = useState([]);

  useEffect(() => {
    const getProducts = async () => {
      try {
        const res = await publicRequest.get(`/products`);
        setProducts(res.data.data);
      } catch (err) {
        console.log(err);
      }
    };
    getProducts();
  }, []);

  // if(error) return 'error....';

  const clearFilters = () => {
    setQuery('');
    setCategoryIndex(-1);
    setPrice(10000);
  };

  return (
    <StoreContext.Provider
      value={{
        query,
        setQuery,
        categoryIndex,
        setCategoryIndex,
        price,
        setPrice,
        sortByIndex,
        setSortByIndex,
        viewGrid,
        setViewGrid,
        products,
        clearFilters,
      }}
    >
      {products ? children : ''}
    </StoreContext.Provider>
  );
};

export { StoreProvider, StoreContext };
